import React, { FC } from "react";
import "./assets/css/progress.css";
interface IProps {
  status?: any;
}

const Progress: FC<IProps> = ({ status }) => {
  return (
    <div
      style={{ display: status ? "block" : "none" }}
      className="progress-main"
    >
      <div className="progress-container">
        <div className="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Progress;
